var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('table',{staticStyle:{"width":"100%","height":"100px"}},[_c('tbody',[_c('tr',[_c('td',{staticClass:"align-middle"},[_c('h2',[_vm._v("Logout in corso...")])])])])])
}]

export { render, staticRenderFns }